(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product"] && !Shopify.designMode) return;
  try {
    
(() => {
class RetreatCountdownElement extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.controller?.abort();
    }
    parseLocalDeadline(date, time, zone) {
      const calendar = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const clock = time.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i) || time.match(/^(\d{1,2}):(\d{2})$/);
      if (!calendar || !clock) return null;
      const [, year, month, day] = calendar.map(Number);
      let hour = Number(clock[1]);
      const minute = Number(clock[2] || 0);
      const period = clock[3]?.toUpperCase();
      if (period) {
        if (hour < 1 || hour > 12) return null;
        hour = hour % 12 + (period === 'PM' ? 12 : 0);
      }
      if (year < 1000 || month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate() || hour > 23 || minute > 59) return null;
      const wallTime = Date.UTC(year, month - 1, day, hour, minute);
      try {
        const formatter = new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', {
          timeZone: zone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
        const wallAt = (instant) => {
          const parts = Object.fromEntries(formatter.formatToParts(new Date(instant)).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
          return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
        };
        const offsets = new Set([-2, 0, 2].map(days => {
          const instant = wallTime + days * 86400000;
          return wallAt(instant) - instant;
        }));
        const matches = [...offsets].map(offset => wallTime - offset).filter(instant => wallAt(instant) === wallTime);
        return matches.length === 1 ? matches[0] : null;
      } catch (_) {
        return null;
      }
    }
    parseDeadline(raw) {
      const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/);
      if (!match) return null;
      const [, year, month, day, hour, minute, second, zone] = match;
      const daysInMonth = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
      if (+month < 1 || +month > 12 || +day < 1 || +day > daysInMonth || +hour > 23 || +minute > 59 || +second > 59) return null;
      if (zone !== 'Z' && (+zone.slice(1, 3) > 14 || +zone.slice(4) > 59 || (+zone.slice(1, 3) === 14 && +zone.slice(4) !== 0))) return null;
      const time = Date.parse(raw);
      return Number.isFinite(time) ? time : null;
    }
    show(selector, visible) {
      const element = this.querySelector(selector);
      if (element) element.hidden = !visible;
    }
    updateDigits(seconds, prefix) {
      const units = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.entries(units).forEach(([unit, value]) => {
        const element = this.querySelector('[data-' + prefix + '-' + unit + ']');
        const text = String(value).padStart(2, '0');
        if (element && element.textContent !== text) element.textContent = text;
      });
    }
}

if (!customElements.get('retreat-launch')) {
  customElements.define('retreat-launch', class extends RetreatCountdownElement {
    initialize() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mode = this.dataset.mode;
      this.content = this.querySelector('[data-retreat-content]');
      this.input = this.querySelector('[data-retreat-code]');
      this.submit = this.querySelector('[data-retreat-submit]');
      this.error = this.querySelector('[data-retreat-error]');
      this.form = this.querySelector('[data-retreat-unlock]');
      this.unlocked = false;
      this.expired = false;
      this.invalid = false;
      const raw = (this.dataset.deadline || '').trim();
      const launchDate = (this.dataset.date || '').trim();
      const launchTime = (this.dataset.time || '').trim();
      const launchZone = this.dataset.timeZone || 'America/Los_Angeles';
      this.deadline = launchDate ? this.parseLocalDeadline(launchDate, launchTime, launchZone) : raw ? this.parseDeadline(raw) : null;
      this.invalid = Boolean((launchDate || raw) && this.deadline === null);
      const deadlineKey = launchDate ? [launchDate, launchTime, launchZone].join('|') : raw;
      this.storageKey = this.dataset.storageKey;
      this.storageValue = (this.dataset.codeHash || '') + ':' + deadlineKey;
      this.show('[data-retreat-invalid]', this.invalid);
      this.tick();
      if (this.mode !== 'public' && this.deadline !== null && !this.expired) this.timer = setInterval(() => this.tick(), 1000);
      if (this.mode !== 'community') return;
      this.ready = Boolean(this.dataset.codeHash && window.crypto?.subtle && !this.invalid);
      if (this.input) this.input.disabled = !this.ready;
      if (this.submit) this.submit.disabled = !this.ready;
      this.show('[data-retreat-unavailable]', !this.ready && !this.expired);
      this.form?.addEventListener('submit', (event) => this.unlock(event), options);
      this.input?.addEventListener('input', () => {
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
      }, options);
      this.querySelector('[data-retreat-relock]')?.addEventListener('click', () => {
        this.forget();
        this.setUnlocked(false);
        this.input?.focus();
      }, options);
      this.addEventListener('submit', (event) => {
        if (this.content?.contains(event.target)) {
          this.tick();
          if (!this.unlocked) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }
      }, { ...options, capture: true });
      let remembered = false;
      if (this.dataset.editor !== 'true') {
        try { remembered = sessionStorage.getItem(this.storageKey) === this.storageValue; } catch (_) {}
      }
      this.setUnlocked(Boolean(remembered && this.ready && !this.expired));
    }
    forget() {
      try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
    }
    setUnlocked(value, focus = false) {
      this.unlocked = Boolean(value && !this.expired && !this.invalid);
      if (this.content) {
        this.content.hidden = !this.unlocked;
        this.content.inert = !this.unlocked;
        if (this.unlocked) this.content.removeAttribute('aria-hidden');
        else this.content.setAttribute('aria-hidden', 'true');
      }
      this.show('[data-retreat-panel]', !this.unlocked);
      this.show('[data-retreat-welcome]', this.unlocked);
      if (this.unlocked) {
        this.dispatchEvent(new CustomEvent('retreat:unlocked', { bubbles: true }));
        window.dispatchEvent(new Event('resize'));
        if (focus) this.querySelector('[data-retreat-welcome-heading]')?.focus();
      }
    }
    async unlock(event) {
      event.preventDefault();
      this.tick();
      if (!this.ready || this.expired || this.invalid || this.submit.disabled) return;
      this.error.hidden = true;
      this.input.removeAttribute('aria-invalid');
      this.submit.disabled = true;
      try {
        const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(this.input.value.trim().toLowerCase()));
        if (!this.isConnected) return;
        const hash = Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
        this.tick();
        if (this.expired) return;
        if (hash !== this.dataset.codeHash) {
          this.error.hidden = false;
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
          return;
        }
        this.input.value = '';
        if (this.dataset.editor !== 'true') {
          try { sessionStorage.setItem(this.storageKey, this.storageValue); } catch (_) {}
        }
        this.setUnlocked(true, true);
      } catch (_) {
        this.show('[data-retreat-unavailable]', true);
      } finally {
        this.submit.disabled = !this.ready || this.expired;
      }
    }
    tick() {
      if (this.deadline === null) {
        if (this.invalid) this.show('[data-retreat-countdown]', false);
        return;
      }
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (seconds === 0) {
        if (!this.expired) {
          this.expired = true;
          clearInterval(this.timer);
          this.show('[data-retreat-countdown]', false);
          this.show('[data-retreat-finished]', true);
          if (this.mode === 'community') {
            const moveFocus = this.content?.contains(document.activeElement) || this.form?.contains(document.activeElement);
            this.forget();
            this.setUnlocked(false);
            this.show('[data-retreat-intro]', false);
            this.show('[data-retreat-expired]', true);
            this.show('[data-retreat-unlock]', false);
            if (this.input) this.input.disabled = true;
            if (this.submit) this.submit.disabled = true;
            if (moveFocus) this.querySelector('[data-retreat-expired-heading]')?.focus();
          }
        }
        return;
      }
      this.updateDigits(seconds, 'retreat');
      this.show('[data-retreat-digits]', true);
    }
  });
}
if (!customElements.get('retreat-booking-countdown')) {
  customElements.define('retreat-booking-countdown', class extends RetreatCountdownElement {
    initialize() {
      clearInterval(this.timer);
      const date = (this.dataset.date || '').trim();
      this.deadline = date ? this.parseLocalDeadline(date, (this.dataset.time || '').trim(), this.dataset.timeZone || 'America/Los_Angeles') : this.parseDeadline((this.dataset.deadline || '').trim());
      this.show('[data-booking-countdown-running]', false);
      this.show('[data-booking-countdown-ended]', false);
      this.show('[data-booking-countdown-invalid]', false);
      this.show('[data-booking-countdown-expired-preview]', false);
      if (this.deadline === null) {
        this.hidden = this.dataset.editor !== 'true';
        this.show('[data-booking-countdown-invalid]', true);
        return;
      }
      if (this.tick()) this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!seconds) {
        clearInterval(this.timer);
        const message = this.dataset.expiry === 'message';
        const preview = this.dataset.editor === 'true' && !message;
        this.hidden = !message && !preview;
        this.show('[data-booking-countdown-running]', false);
        this.show('[data-booking-countdown-ended]', message);
        this.show('[data-booking-countdown-expired-preview]', preview);
        return false;
      }
      this.hidden = false;
      this.show('[data-booking-countdown-running]', true);
      this.updateDigits(seconds, 'booking');
      return true;
    }
  });
}

    if (!customElements.get('retreat-sold-out-style')) {
      customElements.define('retreat-sold-out-style', class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }
        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.observer?.disconnect();
          this.controller?.abort();
        }
        initialize() {
          this.observer?.disconnect();
          this.controller?.abort();
          this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
          if (!this.root) return;
          try { this.stock = JSON.parse(this.dataset.stock); } catch (_) { return; }
          this.buttonSelector = '.product__details button[name="add"], .product__details button.product__submit__add, .product__details button[data-add-to-cart]';
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const update = () => this.update();
          this.root.addEventListener('change', update, options);
          this.root.addEventListener('input', update, options);
          this.root.addEventListener('retreat:unlocked', update, options);
          const guard = (event) => {
            const button = event.type === 'submit'
              ? event.target.querySelector?.(this.buttonSelector)
              : event.target.closest?.(this.buttonSelector);
            if (!button) return;
            const form = button.form || button.closest('form');
            if (this.variantFor(form)?.available === true) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.update();
          };
          this.root.addEventListener('click', guard, { ...options, capture: true });
          this.root.addEventListener('submit', guard, { ...options, capture: true });
          ['variant:change', 'variant:changed', 'theme:variant:change', 'theme:variant:changed', 'product:variant-change', 'product:variantChange', 'variantChange'].forEach((name) => {
            document.addEventListener(name, (event) => {
              const detail = event.detail || {};
              if (detail.sectionId != null && String(detail.sectionId) !== this.dataset.sectionId) return;
              if (detail.sectionId == null && !this.root.contains(event.target)) return;
              if (Object.prototype.hasOwnProperty.call(detail, 'variant')) {
                this.update(detail.variant?.id || '');
              } else this.update();
            }, options);
          });
          this.observer = new MutationObserver(update);
          this.root.querySelectorAll('.product__details').forEach((details) => {
            this.observer.observe(details, {
              childList: true, characterData: true, subtree: true, attributes: true,
              attributeFilter: ['value', 'selected', 'checked', 'disabled', 'aria-disabled']
            });
          });
          this.update();
        }
        variantFor(form, eventVariantId) {
          const controls = Array.from(form?.elements || []).filter((control) => control.name === 'id');
          const hasRadios = controls.some((control) => control.type === 'radio');
          const control = hasRadios ? controls.find((control) => control.type === 'radio' && control.checked) : controls[0];
          let id = controls.length ? control?.value || '' : this.dataset.initialVariant;
          if (eventVariantId !== undefined) id = eventVariantId;
          return this.stock.find((item) => String(item.id) === String(id));
        }
        updateSelectorLabels(scope, variant) {
          if (!scope) return;
          scope.querySelectorAll('.selector-wrapper, [data-popout], .select-popout, .popout').forEach((root) => {
            const toggle = root.querySelector('[data-popout-toggle], .popout__toggle, .select-popout__toggle, [aria-haspopup="listbox"], summary, button');
            if (!toggle) return;
            if (variant?.available === false) {
              if (toggle.dataset.retreatSelectedSoldOut !== 'true') toggle.setAttribute('data-retreat-selected-sold-out', 'true');
            } else if (toggle.hasAttribute('data-retreat-selected-sold-out')) {
              toggle.removeAttribute('data-retreat-selected-sold-out');
            }
          });
        }
        update(eventVariantId) {
          const label = (this.dataset.atcLabel || '').trim();
          const buttons = this.root.querySelectorAll(this.buttonSelector);
          buttons.forEach((button) => {
            const form = button.form || button.closest('form');
            const variant = this.variantFor(form, eventVariantId);
            this.updateSelectorLabels(button.closest('.product__details') || form, variant);
            const text = button.querySelector('[data-add-to-cart-text]') || button;
            if (variant?.available !== true) {
              if (button.dataset.retreatStockBlocked !== 'true') button.setAttribute('data-retreat-stock-blocked', 'true');
              if (variant?.available === false) {
                if (button.dataset.retreatSoldOut !== 'true') button.setAttribute('data-retreat-sold-out', 'true');
              } else if (button.hasAttribute('data-retreat-sold-out')) button.removeAttribute('data-retreat-sold-out');
              if (!button.disabled) button.disabled = true;
              if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
              const blockedLabel = variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
              if (blockedLabel && text.textContent.trim() !== blockedLabel) text.textContent = blockedLabel;
              return;
            }
            if (button.hasAttribute('data-retreat-sold-out')) button.removeAttribute('data-retreat-sold-out');
            if (button.hasAttribute('data-retreat-stock-blocked')) {
              button.removeAttribute('data-retreat-stock-blocked');
              if (!button.matches('[aria-busy="true"], .is-loading, .loading, .btn--loading')) {
                button.disabled = false;
                button.removeAttribute('aria-disabled');
              }
            }
            if (button.disabled || form?.querySelector('[data-product-preorder]')) return;
            const availableLabel = label || text.getAttribute('data-atc-text') || window.theme?.strings?.addToCart;
            if (availableLabel && text.textContent.trim() !== availableLabel) text.textContent = availableLabel;
            if (label && text.getAttribute('data-atc-text') !== label) text.setAttribute('data-atc-text', label);
          });
        }
      });
    }

if (!window.__retreatInfoModals) {
  window.__retreatInfoModals = true;
  const syncBodyClass = () => {
    document.body.classList.toggle('retreat-info-open', Boolean(document.querySelector('dialog[data-retreat-info-modal][open]')));
  };
  const openDialog = (dialog) => {
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
      syncBodyClass();
    }
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-retreat-info-open]');
    if (opener) {
      openDialog(document.getElementById(opener.getAttribute('aria-controls')));
      return;
    }
    const closer = event.target.closest('[data-retreat-info-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (event.target.matches?.('dialog[data-retreat-info-modal]')) event.target.close();
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches?.('dialog[data-retreat-info-modal]')) syncBodyClass();
  }, true);
  document.addEventListener('shopify:block:select', (event) => {
    openDialog(event.target.querySelector?.('dialog[data-retreat-info-modal]'));
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.querySelector?.('dialog[data-retreat-info-modal][open]')?.close();
  });
}
})();

  } catch(e) { console.error(e); }
})();
})();
